import styled from "styled-components";
import tw from "twin.macro";
import { Theme } from "./context";

export const Container = styled.div`
  ${tw`max-w-[100vw] mx-auto xl:px-20`}

  @media screen and (max-width:1024px) {
    width: calc(100vw - 100px);
  }

  @media screen and (max-width: 768px) {
    width: calc(100vw - 70px);
  }

  @media screen and (max-width: 500px) {
    width: calc(100vw - 50px);
  }
`;

export const LayoutContainer = styled.div<{ rooTheme?: Theme }>`
  position: relative;
  background: ${({ rooTheme }) =>
    rooTheme === "dark" ? tw`bg-basebackground h-[100vh]` : tw`bg-white `};
`;

export const Toggler = styled.div<{ rooTheme?: Theme }>`
  ${tw`mx-4 text-3xl cursor-pointer`};
  background: ${({ rooTheme }) =>
    rooTheme === "dark" ? tw`bg-transparent` : tw`bg-transparent`};
`;
